export default (value) => {
	const reg = /[,.]+$/g

	let _value = '' + value
	_value.replace(reg, '')
	
	return parseFloat(_value, 10)
}